import { Configuration, PublicClientApplication } from '@azure/msal-browser'

export const msalConfig: Configuration = {
  auth: {
    clientId: 'fd1442d1-cbcc-4b73-a893-a61b8d3d4782',
    authority: 'https://sistemiv.b2clogin.com/sistemiv.onmicrosoft.com/B2C_1_SIGN_UP_AND_SIGN_IN',
    redirectUri: '/',
    postLogoutRedirectUri: '/',
    knownAuthorities: ['sistemiv.b2clogin.com'],
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
}

export const loginRequest = {
  scopes: ['openid', 'fd1442d1-cbcc-4b73-a893-a61b8d3d4782'],
}

export const msalInstance = new PublicClientApplication(msalConfig)
